import React from "react";
import PropTypes from "prop-types";
import SidebarContent from "./sidebarContent";

interface SidebarProps {
  type?: any;
  toggleMenuCallback: () => void;
}

const Sidebar: React.FC<SidebarProps> = (props) => {
  

  return (
    <>
      <div className="vertical-menu">
        <div data-simplebar className="h-100">
          {props.type !== "condensed" ? <SidebarContent toggleMenuCallback={props.toggleMenuCallback} type={""} /> : <SidebarContent toggleMenuCallback={props.toggleMenuCallback} type={""} />}
        </div>
        <div className="sidebar-background"></div>
      </div>
    </>
  );
};

Sidebar.propTypes = {
  type: PropTypes.string,
};

export default Sidebar;
